import api from '~api'
import moment from 'moment'
import {
  convertEnterpriseRequest,
  convertEnterpriseResponse,
  convertPages,
  convertCampusRecruitingDetailsBasicInfo,
  // converCampusRecruitingDetailsSpecialIssue,
  converCampusRecruitingDetailsEnrolledExpo,
  converCampusRecruitingDetailsEnrolledOrientations,
  converCampusRecruitingDetailsEnrolledAdvertisements,
  convertCampusRecruitmentRequest,
  convertJobOpeningRequest,
  convertJobDetailsForEnterprise
} from '~utils/api'
export const url = `/enterprise`

export async function postEnterpriseLogin ({
  id, password
}) {
  const {
    data
  } = await api.post(`${url}/login`, {
    account: id,
    password
  })

  return {
    token: data.access_token,
    token_expired_at: moment().add(data.expires_in, 's')._d
  }
}

export async function postEnterpriseSignup (email) {
  const {
    data
  } = await api.post(`${url}/send-email`, {
    email
  })

  return data
}

export async function postEnterpriseRegister (profile) {
  const request = convertEnterpriseRequest(profile)
  const others = {
    register_email: profile.enterprise_registered_email,
    token: profile.token,
    password: profile.password || '',
    password_confirmation: profile.password_confirmation || ''
  }

  Object.keys(others).forEach(key => {
    request.append(`${key}`, others[key])
  })

  const {
    data
  } = await api.post(`${url}/register`, request, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return data
}

export async function getEnterprise () {

  try {
    const {
      data
    } = await api.get(`${url}`)
  
    const response = data.data
  
    const enterprise = convertEnterpriseResponse(response)
  
    return enterprise
  } catch (error) {
    console.debug(error);
  }

}

export async function putEnterprise (profile) {
  const request = convertEnterpriseRequest(profile)
  request.append('_method', 'PUT')

  if (profile.password) {
    try {
      await putEnterprisePassword(profile)
    } catch (err) {
      return false
    }
  }

  const { data } = await api.post(`${url}`, request, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return convertEnterpriseResponse(data.data)
}

export async function getEnterpriseReminder () {
  const {
    data
  } = await api.get(`/getReminder`)

  return data
}

export async function putEnterprisePassword (profile) {
  const passwordRequest = {
    password: profile.password,
    password_confirmation: profile.password_confirmation
  }
  const {
    data
  } = await api.put(`${url}/reset-password`, passwordRequest)

  return data
}

export async function getEnterpriseLogout () {
  const {
    data
  } = await api.get(`${url}/logout`)
  return data
}

export async function getEnterpriseJobList (params) {
  const {
    data
  } = await api.get(`${url}/job/list`, {
    params
  })

  const jobs = data.data.map((job) => {
    return {
      job_id: job.id,
      job_title: job.name,
      job_created_at: job.created_at,
      job_publishing_deadline: job.deadline || '',
      job_identity: (job.identities.length) ? job.identities[0].name : '',
      job_opening_status: !!((job.deadline === null || moment().isBefore(job.deadline)))
    }
  })

  const pages = convertPages(data.meta)
  return {
    jobs, pages
  }
}

export async function postEnterpriseForgetPassword (account) {
  const {
    data
  } = await api.post(`${url}/send-forget-email`, {
    account
  })

  return data
}

export async function postEnterpriseResetPassword (params) {
  const {
    data
  } = await api.post(`${url}/forget-password`, params)

  return data
}

export async function getEnterpriseJobById (id) {
  const {
    data
  } = await api.get(`${url}/job/list/${id}`)

  const response = data.data

  const job = convertJobDetailsForEnterprise(response)
  return job
}

export async function postEnterpriseJobList (job) {
  const request = convertJobOpeningRequest(job)

  const {
    data
  } = await api.post(`${url}/job/list`, request, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return data
}

export async function patchEnterpriseJobList ({ id, job }) {
  const request = convertJobOpeningRequest(job)
  request.append('_method', 'PATCH')

  const {
    data
  } = await api.post(`${url}/job/list/${id}`, request, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  return data
}

export async function deleteEnterpriseJobList (ids) {
  const params = {
    ids
  }

  const {
    data
  } = await api.delete(`${url}/job/list`, { params })

  return data
}

export async function getCampusRecruitments (params) {
  const {
    data
  } = await api.get(`${url}/school-hire-form`, { params })

  const recruitments = data.data.map((recruitment) => {
    return {
      recruitment_id: recruitment.id,
      recruitment_name: recruitment.name
    }
  })

  const pages = convertPages(data.meta)

  return { recruitments, pages }
}

export async function getEnterpriseEnrolledCampusRecruitmentById (id) {
  const {
    data
  } = await api.get(`${url}/school-hire-form/${id}`)

  const response = data.data
  const basicInfo = convertCampusRecruitingDetailsBasicInfo(response)
  // const specialIssue = converCampusRecruitingDetailsSpecialIssue(response.enlistForm)
  const enrolledExpo = converCampusRecruitingDetailsEnrolledExpo(response.enlistForm)
  const enrolledOrientations = converCampusRecruitingDetailsEnrolledOrientations(response.enlistForm.enlistSeminarSessions)
  const enrolledAdvertisements = converCampusRecruitingDetailsEnrolledAdvertisements(response.enlistForm.enlistCommodities)
  const enlistExpositionBoothTime = ((response) => {
      return response ? {time: response.time} : {};
  })(response.enlistForm.enlistExpositionBooth);
  const enterpriseId = response.enlistForm.enterprise_id

  return {
    basicInfo,
    // specialIssue,
    enrolledExpo,
    enrolledOrientations,
    enrolledAdvertisements,
    enlistExpositionBoothTime,
    enterpriseId
  }
}

export async function postCampusRecruitmentEnrollment (enrollment) {
  const request = convertCampusRecruitmentRequest(enrollment, 'post')

  const {
    data
  } = await api.post(`${url}/school-hire-form`, request, {
    headers: {
      'No-Success-Notification': 'true'
    }
  })

  return data
}

export async function patchCampusRecruitmentEnrollment (enrollment) {
  const request = convertCampusRecruitmentRequest(enrollment, 'put')
  const {
    data
  } = await api.patch(`${url}/school-hire-form/${enrollment.campus_recruitment_id}`, request)

  return data
}

export async function patchCareerExpoBooths ({ id, boothNumbers }) {
  const request = {
    booth_numbers: boothNumbers
  }

  const {
    data
  } = await api.patch(`${url}/school-hire-booth/${id}`, request)

  return data
}

export async function getCareerExpoBoothsStatus (id) {
  const {
    data
  } = await api.get(`${url}/school-hire-booth/${id}/status`)

  const careerExpoBoothsStatus = data.data.status;

  return {
    careerExpoBoothsStatus
  }
}

export async function postBookingACareerExpoBooth ({ id, boothNumber }) {
  const request = {
    booth_number: boothNumber
  }

  const { data } = await api.post(`${url}/school-hire-booth/${id}/add`, request)

  return data
}

export async function deleteBookedCareerExpoBooth ({ id, boothNumber }) {
  const data = {
    booth_number: boothNumber
  }

  const { data: response } = await api.delete(`${url}/school-hire-booth/${id}/destroy`, { data })

  return response
}

export async function bookedCareerExpoBoothRename ({ id, names }) {
  const params = names.map(obj => ({
    booth_id: obj.booth_id,
    booth_name: obj.booth_name,
  }))
  const data = {
    data: params
  }

  const {
    data: response
  } = await api.post(`${url}/school-hire-booth/${id}/rename`, data)

  return response
}

export async function getEnterpriseBoothAuthorizationRecordById (id) {
  const {
    data
  } = await api.get(`${url}/school-hire-booth/${id}/list`)

  const authorizationRecord = data.data

  return {
    authorizationRecord,
  }
}

export async function getEnterpriseBoothAuthorizationGiveById ({ id, give_amount }) {
  const {
    data
  } = await api.post(`${url}/school-hire-booth/${id}/give`, { id, give_amount })

  const authorizationCode = {
      code: data.code,
      expirationTime: moment(data.created_at).add(2, 'h').format('YYYY/MM/DD hh:mm'),
  }

  return {
    authorizationCode,
  }
}

export async function getEnterpriseBoothAuthorizationTakeById ({ id, code }) {
  const {
    data
  } = await api.post(`${url}/school-hire-booth/${id}/take`, { id, code })

  const response = data;

  return response
}

export async function sendEnterpriseInternForm (internBasicInfo) {
  const {
    data
  } = await api.post(`${url}/intern/sendForm`, internBasicInfo)

  const response = data;

  return response
}

export async function getPassEnterpriseInternForm () {
  const {
    data
  } = await api.get(`${url}/intern/getForm/passInfo`)

  const internBasicInfo = data.data || null;
  return {
    internBasicInfo,
  }
}

export async function getEnterpriseInternForm () {
  const {
    data
  } = await api.get(`${url}/intern/getForm`)

  const internBasicInfo = data.data || null;
  const internStatus = (() => {
    if(!internBasicInfo) return 'unapplied_or_expired';
    else if(!internBasicInfo.is_enabled) return 'under_review';
    else return 'is_enabled';
  })();

  return {
    internBasicInfo,
    internStatus,
  }
}

export async function updateEnterpriseInternForm (internBasicInfo) {
  const {
    data
  } = await api.put(`${url}/intern/updateForm`, internBasicInfo)

  const response = data;

  return response
}

export async function getInternSearchOptions () {
  const {
    data
  } = await api.get(`${url}/intern/getInternSearchOptions`)
  
  const internSearchOptions = data;

  return {
    internSearchOptions,
  }
}

export async function getInternRecordList (params) {
  const {
    data
  } = await api.get(`${url}/intern/getInternRecordList`, { params })

  const internRecordList = data.data.map(record => ({
    year: record.year,
    department: record.department,
    department_id: record.department_id,
    student_account: record.account,
    student_name: record.name,
    student_id: record.student_id,
  }));

  return {
    internRecordList,
  }
}

export async function sendInternForm ({type, params}) {
  const {
    data
  } = await api.post(`${url}/form/${type}/sendForm`, params)

  return data
}

export async function getInternForm ({ type, params }) {
  const {
    data
  } = await api.get(`${url}/form/${type}/getForm`, { params })

  const formData = data.data;
  
  return {
    formData
  }
}
